import { render, staticRenderFns } from "./WrapperStatus.vue?vue&type=template&id=68a76763&scoped=true&"
import script from "./WrapperStatus.vue?vue&type=script&lang=js&"
export * from "./WrapperStatus.vue?vue&type=script&lang=js&"
import style0 from "./WrapperStatus.vue?vue&type=style&index=0&id=68a76763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a76763",
  null
  
)

export default component.exports